import React from "react";
import { Tag } from "lucide-react";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";

/**
 * Inline "list this channel on the marketplace" panel. Parent
 * (ChannelsTab) controls visibility via the `target` prop.
 *
 * Props:
 *   target  — { id, username } of the channel being listed (null = hidden)
 *   price   — current input value
 *   onPrice — price setter
 *   busy    — true while POST /marketplace/listings is in flight
 *   onSubmit, onCancel — caller-supplied handlers
 */
const ChannelListPanel = ({ target, price, onPrice, busy, onSubmit, onCancel }) => {
  if (!target) return null;
  // 15% platform commission — the seller's take-home is the price minus
  // GlobalEyes' cut. Rendered in real-time so the seller can dial in a
  // price that nets the number they actually want to walk away with.
  const takeHome = Math.round(Number(price || 0) * 0.85);
  return (
    <div className="bg-blue-500/5 border border-blue-500/30 rounded-lg p-3 mb-4" data-testid="list-panel">
      <p className="text-blue-200 text-sm font-medium mb-2 flex items-center gap-2">
        <Tag className="h-4 w-4" /> List /{target.username} on the marketplace
      </p>
      <p className="text-xs text-gray-400 mb-3 leading-relaxed">
        Buyers inherit the handle, all videos, and the entire follower base.
        GlobalEyes takes a <strong className="text-gray-200">15% commission</strong>;
        you keep the rest. Master accounts and viewers can never see who you are.
      </p>
      <div className="flex gap-2 mb-3">
        <Input
          type="number"
          min={100}
          value={price}
          onChange={(e) => onPrice(e.target.value)}
          className="bg-black border-gray-700 text-white text-sm"
          placeholder="Price in credits (min 100)"
          data-testid="list-price-input"
        />
        <Button
          onClick={onSubmit}
          disabled={busy}
          className="bg-blue-600 hover:bg-blue-700 text-xs"
          data-testid="list-confirm"
        >
          {busy ? "Listing..." : `List · take home ${takeHome.toLocaleString()} cr`}
        </Button>
        <Button variant="outline" onClick={onCancel} className="border-gray-700 text-gray-300 text-xs">
          Cancel
        </Button>
      </div>
      <p className="text-[10px] text-gray-500">
        Channel must be ≥ 7 days old. One active listing per channel at a time.
      </p>
    </div>
  );
};

export default ChannelListPanel;
